import React, { useCallback } from 'react';
import DefinitionCard from '../../../../Elements/DefinitionCard';
import ShowNameComponent from '../../../../Elements/ShowNameComponent';
import CurrencyService from '../../../../Services/CurrencyService';
import contactService from '../../../../Services/contactService';
import useBackendData from '../../../../Helpers/useBackendData';
import {
  getInvoiceSettingsRows,
  getInvoiceTextRows,
  getOtherProjectsRow,
  getSetupSettingsRows,
  parseSettingsSnapshot,
} from '../../../../Helpers/invoiceAutomationSettingsHelper';

// The settings a run of automatic invoicing ran with, from the snapshot it stored: the setup's own settings with the
// other projects on its invoice, then each invoice's. The other projects come named from the server (otherProjects);
// the bill-to contact is looked up among the client's contacts and the currency by its id.
export default function InvoiceAutomationRunSettings({ settingsSnapshot = null, otherProjects = [], clientId = null }) {
  const loadContacts = useCallback(
    () => (clientId ? contactService.GetContactListByClientId(clientId) : Promise.resolve([])),
    [clientId]
  );
  const { data: contacts } = useBackendData(
    loadContacts,
    "Error! ErrorCode: IARS23. Failed to load the client's contacts."
  );

  const snapshot = parseSettingsSnapshot(settingsSnapshot);
  if (snapshot === null) {
    return <p>The settings of this run cannot be shown.</p>;
  }

  function getContactName(contactId) {
    const contact = (contacts ?? []).find((candidate) => candidate.contactId === contactId);
    return contact ? contact.name : `#${contactId}`;
  }

  return (
    <div className='def-cols'>
      <DefinitionCard rows={[...getSetupSettingsRows(snapshot), getOtherProjectsRow(otherProjects)]} />
      {(snapshot.Invoices ?? []).map((invoice) => (
        <React.Fragment key={invoice.InvoiceAutomationInvoiceId}>
          <DefinitionCard
            rows={[
              { label: 'Bill-to contact', value: getContactName(invoice.ContactId) },
              {
                label: 'Currency',
                value: (
                  <ShowNameComponent
                    id={invoice.CurrencyId}
                    serviceFunction={CurrencyService.GetCurrencyNameById}
                  />
                ),
              },
              ...getInvoiceSettingsRows(invoice),
            ]}
          />
          <DefinitionCard rows={getInvoiceTextRows(invoice)} />
        </React.Fragment>
      ))}
    </div>
  );
}
